import { Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { LmsContentEditorComponent } from '../lms-content-editor/lms-content-editor.component';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-lms-content',
  templateUrl: './lms-content.component.html',
  styleUrls: ['./lms-content.component.scss'],
})
export class LmsContentComponent implements OnInit {
  selectedItem = 'All'
  searchValue: ''
  isDragDropEnabled: boolean = true;
  s3MediaUrl = environment?.apiUrls?.s3MediaUrl
  @Input() courseId: any
  @Input() topicId: any 
  @Input() isReadMode: any 
  apps: any[] = []
  @Input() topics:any = []
  isLoading: boolean = false;
  @Input() appsByTopic: any[] = []
  @Output() refreshData = new EventEmitter<any>();
  isAppBtns: boolean = false
  appType: any;
  @ViewChild('modalRef') modal: LmsContentEditorComponent;
  sanitizedUrl: SafeHtml;
  sanitizedContent: SafeHtml;
  selectedApp: any;
  user:any
  assignment_model={
    student_id: '',
    course_id: '',
    topic_id: '',
    app_id: '',
    title: '',
    notes: '',
    admin_notes: ''
  }
  isAddFormShow: boolean = true;
  isSubmitted :any
  selectedAppContent: number =0;
  resources_list=[]
  selected_resources = []
  app_tag_cat_id= '648956a313fb47cb1a45e844' //'648058e70c699e0bd984ec30'
  app_tags_list=[]
  selected_app_tag ='64884b753ec230f996841247'
  lms_model={
    content_scripts: '',
    teachers_notes: '',
    description	: '',
  }
  modalFor
  file :File
  app_id
  formData = new FormData()
  empType =[]
  recentApi:string
  current_index:number
  constructor(private router: Router,
    private toast: ToastrService,
    private _sanitizer: DomSanitizer,
    private apiService: ApiService,private modalService: NgbModal,) { 
      this.user =JSON.parse(localStorage.getItem('user'))
      if(this.user.roles !=='admin' && this.user.roles !=='student'  ){
        this.empType = this.user.employeetype.map(item=>item.displayname)
      }       
    
    }   
  ngOnInit(): void {
    this.refreshData.emit()
    this.appTags()
    this.getResourceList()
  }
  onApiStatusUpdate(apiName:string){
    this.recentApi = apiName
  }
 
  ngOnChanges() {
    if (!this.appsByTopic) return;

    this.isLoading = true;
    this.apps = [...this.appsByTopic];
    this.updateSelectedAppContent();
    this.isAddFormShow = this.apps.length > 0 ? false : true
    // this.sanitizedContent = this.apps[0]?.content?this.getSanitizedHtml(this.apps[0]?.content):this.apps[0]?.content;
    if(this.user.id && this.topicId && this.apps[0]?._id){
      this.checkAssignmentIsSubmit(this.user.id,this.topicId,this.apps[0]?._id)
    }

    setTimeout(() => {
      this.apps.forEach((app) => {
        this.sanitizedContent = app?.content?this.getSanitizedHtml(app?.content):app?.content
        this.isLoading = false;
      });
      this.isLoading = false;
    }, 3000);
  }
  private updateSelectedAppContent(): void {
    switch (this.recentApi) {
      case 'Add API':
        this.selectedAppContent = this.apps.length-1;
        break;
      case 'Update API':
        this.current_index = this.selectedAppContent
        break;
    }
  }
 

  closeModel(): void {
    this.refreshData.emit()
  }
  getSanitizedHtml(data:any): SafeHtml {
    const formattedText = data.replace(/<[^>]+>/g, '');
    const formattedTextWithoutSpaces = formattedText.replace(/&nbsp;/g, ' ');
    return this._sanitizer.bypassSecurityTrustHtml(formattedTextWithoutSpaces);
  }

  formatHtml(videoURL) {
    return JSON.parse(videoURL);
  }
  searchApp(value) {
    if (value) {
      this.isLoading = true;
      this.apiService.searchApp(1, 100, this.selectedItem, value).subscribe((res: any) => {
        if (res?.isSuccess) {
          this.isLoading = false;
          this.isAddFormShow = false
          this.isDragDropEnabled=false;
          this.searchValue = "", this.apps = res?.data?.items
          
        }
      })
    }

  }
  addApp(app) {
    this.modal.resetModalContent();
    this.appType = app
    

    // const queryParams = {
    //   app: app,
    //   courseId: this.courseId,
    //   topicId: this.appsByTopic?.length ? null : this.topicId
    // };
    // this.router.navigate([`/edit-content`], { queryParams })
  }
  addApp2(app,topic_id){
    this.modal.resetModalContent();
    this.topicId = topic_id
    this.appType = app
  }
  connectDisconnect(appId) {
    let model = {
      appId: appId,
      topicId: this.topicId
    }
    let path = this.isConnected(appId) ? 'removeApp' : 'addApps'
    swal.fire({
      title: 'Are you sure?',
      text: `You won't be able to ${this.isConnected(appId) ? 'Disconnect' : 'Connect'} app!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: `Yes, ${this.isConnected(appId) ? 'Disconnect' : 'Connect'} it!`,
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
      buttonsStyling: false,
    }).then((result) => {
      if (result.value) {
        this.apiService.attachOrRemoveApp(path, model).subscribe((res: any) => {
          if (res?.isSuccess) {
            swal.fire({
              icon: "success",
              title: `${this.isConnected(appId) ? 'Disconnect' : 'Connect'}`,
              text: `${res.message}`,
              customClass: {
                confirmButton: 'btn btn-success'
              },
            })
            if(res.message ==='app removed from topic.'){
              this.refreshData.emit()
              this.selectedAppContent =0
            }
          }
          else {
            swal.fire({
              title: 'Error',
              text: `${res.error}`,
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success'
              },
            })
          }
        })
      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });


  }
  isConnected(appId) {
    return this.appsByTopic.some((item) => item._id == appId)
  }
  editApp(app) {
    this.selectedApp = app
  }

  items: string[] = ['Option 1', 'Option 2', 'Option 3'];
  searchTerm: string;


  get filteredItems$(): string[] {
    return this.searchTerm ? this.filterItems(this.searchTerm) : [];
  }

  filterItems(value: string): string[] {
    return this.topics.filter(item =>
      item.name.toLowerCase().includes(value.toLowerCase())
    );
  }

  selectItem(item: string): void {
    this.searchTerm = item;
  }
  resourceDelete(app_id,resource_id){
    // console.log('app_id',app_id,'resource_id',resource_id)
    let body={
      resource: resource_id,
      app: app_id
    }
  
    swal.fire({
      title: 'Are you sure?',
      text: `You won't be able to delete!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: `Yes, delete it!`,
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
      buttonsStyling: false,
    }).then((result) => {
      if (result.value) {
        this.apiService.attachOrRemoveResourceApp(body).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.toast.success('Delete resource successfully ')
            this.refreshData.emit()
    
          }
          else{
            this.toast.error(res.error)
          }
        })
      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  openModalForAssignment(content,userId,appId,courseId,topicId) {
   
    this.assignment_model.student_id = userId
    this.assignment_model.app_id = appId
    this.assignment_model.course_id = courseId
    this.assignment_model.topic_id = topicId
    const options: NgbModalOptions = {
      size: 'md', // set the size of the modal
      backdrop: 'static', // set whether clicking outside the modal closes it
      centered: true // set whether the modal is centered vertically
    };
    
    const modalRef = this.modalService.open(content,options);

    modalRef.result.then((result) => {
    });
   
  }
  assignmentSubmit(){
    this.apiService.createAssignment(this.assignment_model).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.toast.success("Assignment submit successfull!")
        this.modalService.dismissAll()
        this.checkAssignmentIsSubmit(this.user.id,this.topicId,this.apps[0]?._id)
      }
      else this.toast.error(res?.error)
    })
  }
  checkAssignmentIsSubmit(userId,topicId,appId){
    this.apiService.checkAssignmentSubmitByStudent(userId,topicId,appId).subscribe((res:any)=>{
      this.isSubmitted = res?.data
    })
  }
  showContent(index: number): void {
    this.selectedAppContent = index;
    this.current_index =index
    this.isAddFormShow = false
  }
  appTags(){
    this.apiService.getTagByTagCatgoryId(this.app_tag_cat_id).subscribe((res: any) => {
      if(res.statusCode===200){
        this.app_tags_list = res?.data
      }
    })
  }
getAppTagId(event:any){
  this.selected_app_tag
}
getResourceList() {
  this.apiService.getResourceList(1, 100).subscribe((res: any) => {
    if(res.statusCode === 200){
      this.resources_list = res?.items
    }
  })
}
getResourceId(event:any){
  this.selected_resources
}
openModalForUpdateContent(content,data,id,prop) {
  this.app_id = id
    if(prop === 'Description'){
      this.modalFor = prop
      this.lms_model.description = data.description
      if(data.mimetype === "image/jpeg" || data.mimetype ==="video/mp4"){
        this.file = data.content
      }
    }
    if(prop === 'Content Script'){
      this.modalFor = prop
      this.lms_model.content_scripts = data.content_scripts
      if(data.mimetype === "image/jpeg" || data.mimetype ==="video/mp4"){
        this.file = data.content
      }
    }
    if(prop === 'Teacher Notes'){
      this.modalFor = prop
      this.lms_model.teachers_notes = data.teachers_notes
      if(data.mimetype === "image/jpeg" || data.mimetype ==="video/mp4"){
        this.file = data.content
      }
    }
    if(prop === 'App Tag'){
      this.modalFor = prop
      this.selected_app_tag = data.app_tag[0]?._id
      if(data.mimetype === "image/jpeg" || data.mimetype ==="video/mp4"){
        this.file = data.content
      }
    }
    if(prop === 'Resources'){
      this.modalFor = prop
      this.selected_resources = data.resources.map(item => item._id)
      if(data.mimetype === "image/jpeg" || data.mimetype ==="video/mp4"){
        this.file = data.content
      }
    }
  const options: NgbModalOptions = {
    size: 'lg', // set the size of the modal
    backdrop: 'static', // set whether clicking outside the modal closes it
    centered: true // set whether the modal is centered vertically
  };
  
  const modalRef = this.modalService.open(content,options);

  modalRef.result.then((result) => {
    this.modalService.dismissAll()

    this.app_id = null
    this.modalFor = null
    this.lms_model.description = null
    this.lms_model.content_scripts = null
    this.lms_model.teachers_notes = null
    this.selected_app_tag = null
    this.selected_resources = null
    this.selected_app_tag =  null
    this.file = null
  }, (reason) => {
    this.app_id = null
    this.modalFor = null
    this.lms_model.description = null
    this.lms_model.content_scripts = null
    this.lms_model.teachers_notes = null
    this.selected_app_tag = null
    this.selected_resources = null
    this.selected_app_tag =  null
    this.file = null

  });
 
}
updateContent(){
  if(this.modalFor === 'Description'){
    this.formData.append('description',this.lms_model.description)
    this.formData.append('file',this.file)
  }
  if(this.modalFor === 'Content Script'){
    this.formData.append('content_scripts',this.lms_model.content_scripts)
    this.formData.append('file',this.file)

  }
  if(this.modalFor === 'Teacher Notes'){
    this.formData.append('teachers_notes',this.lms_model.teachers_notes)
    this.formData.append('file',this.file)

  }
  if(this.modalFor === 'App Tag'){
    this.formData.append('app_tag',this.selected_app_tag)
    this.formData.append('file',this.file)

  }
  if(this.modalFor === 'Resources'){
    this.selected_resources.forEach((resources, index) => {
      this.formData.append(`resources[${index}]`, resources);
    });
    this.formData.append('file',this.file)

  }
  this.apiService.updateApp(this.app_id,this.formData).subscribe((res:any)=>{
    
      this.toast.success(res?.message)
      this.getAppsByTopic()
      this.modalService.dismissAll()
  })
}
getAppsByTopic() {
  let pageSize = 25
  let pageNo = 1
 
  this.apiService.getAppsByTopic(this.topicId, pageSize, pageNo).subscribe((res: any) => {
    if (res.isSuccess) {
      this.appsByTopic = res.data.map((item) => item.app)
    }
  })
}
toggleView() {
  this.isAddFormShow = !this.isAddFormShow;
}

onDragDropContent(event: CdkDragDrop<any>,type) {
  let apps = {
    indexFrom: event.previousIndex,
    indexTo: event.currentIndex,
    topicId: this.topicId
  };
  swal.fire({
    title: `Do you want to change?`,
    showCloseButton: true,
    showCancelButton: true,
    focusConfirm: false,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    buttonsStyling: false,
    customClass: {
      confirmButton: 'btn btn-primary',
      cancelButton: 'btn btn-danger ml-1'
    },
  }).then((result) => {
    if (result.isConfirmed) {
      moveItemInArray(this.apps, event.previousIndex, event.currentIndex);
      this.apiService.changeOrder(type, apps).subscribe((res: any) => {
        this.selectedAppContent=event.currentIndex;
      });
    }
  });
  }

  copyApp(id) {
    // this.router.navigate(['/lms-content',id])
    let url = `https://do.meander.software/lms-content/${id}`
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = url
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toast.info('copy content url')
  }

 getWhatsappShareUrl(appId: string): string {
   const text = `Check out this app : https://do.meander.software/lms-content/${appId}`
    const encodedText = encodeURIComponent(text);
    return `https://api.whatsapp.com/send?text=${encodedText}`;
  }

  // Function to generate Facebook share URL with app ID
  getFacebookShareUrl(appId: string): string {
    const url = `Check out this app : https://do.meander.software/lms-content/${appId}`; // URL to share
    return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
  }

  // Function to generate Email share URL with app ID
  getEmailShareUrl(appId: string): string {
    const subject = encodeURIComponent('Check out this app');
    const body = encodeURIComponent(`Here is an interesting app: https://do.meander.software/lms-content/${appId}`);
    return `mailto:?subject=${subject}&body=${body}`;
  }

 
}

